import PieveSymbol from './PieveSymbol.jsx';
import Spinner from '../primitives/Spinner.jsx';

/** Full-page wait while the app learns who is signed in. */
const BootScreen = () => {
  return (
    <div className="comp-boot" role="status" aria-live="polite">
      <PieveSymbol size={32} label="Pieve" />
      <span className="comp-boot__line">
        <Spinner size={14} />
        Opening your workspace
      </span>
    </div>
  );
};

export default BootScreen;
